/**
 * @author Yaochao
 * @date 2022/2/16 17:07
 * @description
 */
import React, {forwardRef, useCallback, useEffect, useImperativeHandle, useState} from 'react'
import {Alert, Badge, Button, Divider, Input, Radio, Space, Tooltip} from 'antd';
import ImLink from "./common/link/link";
import ImPicture from "./common/picture/picture";
import ImEmoji from "./common/emoji/emoji";
import ImFile from "./common/file/file";
import IconEdit from "./iconfont/edit/edit";
import CloudApi from "../cloud/cloud_api";
import Message from "../common/message";
import Remind from "./common/remind/remind";
import MixedMessageParser from "../public/mixedMessageParser";
import ImLogin from "./common/login/imLogin";
import Util from "../public/utils";
import md5 from "js-md5";
import ZkModal from "../common/modal/zkModal";
import txt from "./image/file/txt.png";
import ppt from "./image/file/ppt.png";
import word from "./image/file/word.png";
import excel from "./image/file/excel.png";
import pdf from "./image/file/pdf.png";
import zip from "./image/file/zip.png";
import offLine from "./image/offLine/offLine.png";
import unknownFile from "./image/messageList/unknownFile.png";
import MessageListClass from "./common/messageList/messageList_class";
import {nanoid} from "nanoid";
import PubSub from 'pubsub-js'
import RecordIcon from "./common/chatRecord/recordicon";
import Vars from "../cmpts/system_vars";
import Store from "../store";

const {TextArea} = Input
let timer = null
const ChatRoom = forwardRef((props, ref) => {
    const {
        wxid, chat_wxid, chatData, chatDataSelf,
        outSocket, reCallSocket, reSendSocket,
        nextUnRead, endConversation, leftSelect,
        leftUpdate,
    } = props
    const [inputValue, setInputValue] = useState('')
    const [textMsg, setTextMsg] = useState('')
    const [newMsg, setNewMsg] = useState('')
    const [roomInput, setRoomInput] = useState(false)
    const [roomName, setRoomName] = useState('')
    const [msgList, setMsgList] = useState([])
    const [readNum, setReadNum] = useState(0)
    const [oneRemind, setOneRemind] = useState([])
    const [roomTotal, setRoomTotal] = useState(0)
    const [unReadTotal, setUnReadTotal] = useState(0)
    const [isOver, setIsOver] = useState(false)
    const [pages, setPages] = useState(1)
    const [pasterData, setPasterData] = useState({})
    const [loading, setLoading] = useState(false)
    const [dropEnter, setDropEnter] = useState(false)


    const textAreaRef = React.useRef(null);
    const msgListRef = React.useRef(null);
    const remindRef = React.useRef(null);
    const imLoginRef = React.useRef(null);
    const pasterModalRef = React.useRef(null);

    useEffect(() => {
        // console.log('7777777', wxid, '----', chat_wxid, '------', chatData)
        setRoomName(chatData.name)
        //群聊人数
        if (chatData.isRoom == 1) {
            CloudApi.getChatRoomMember(chat_wxid, data => {
                setRoomTotal(data.list.length)
            }, error => {
            })
        }
        setInputValue(Store.getChatSendMsg())
    }, [wxid, chat_wxid, chatData])


    useEffect(() => {
        document.addEventListener('paste', onPaste);
        onDrop()

        //useEffect的返回值代表willunmonut回调
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
            document.removeEventListener('paste', onPaste)
        }
    }, [])

    useEffect(() => {
        let token = PubSub.subscribe('COPY_TO_INPUT_FIELD', (msg, data) => {
            let value = inputValue + data
            textAreaRef.current.focus()
            setInputValue(value)
        })
        return () => {
            PubSub.unsubscribe(token)
        }
    }, [inputValue])

    //拖拽文件处理回调
    const onDrop = () => {
        let dropZone = document.querySelector('#im-chat-root');
        let dropZoneMask = document.querySelector('#im-chat-root-mask');
        dropZone.addEventListener("dragenter", function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (!dropEnter) {
                setDropEnter(true)
            }
            // console.log('9898', 'dragenter')
        }, false);

        dropZone.addEventListener("dragover", function (e) {
            e.preventDefault();
            e.stopPropagation();
            // console.log('9898','dragover' )
        }, false);

        dropZoneMask.addEventListener("dragleave", function (e) {
            e.preventDefault();
            e.stopPropagation();
            setDropEnter(false)
            // console.log('9898','dragleave' )
        }, false);

        dropZone.addEventListener("drop", function (e) {
            e.preventDefault();
            e.stopPropagation();
            setDropEnter(false)
            let df = e.dataTransfer;
            let dropFiles = []; // 拖拽的文件，会放到这里
            let dealFileCnt = 0; // 读取文件是个异步的过程，须要记录处理了多少个文件了
            let allFileLen = df.files.length; // 全部的文件的数量，给非Chrome浏览器使用的变量

            // 检测是否已经把全部的文件都遍历过了
            function checkDropFinish() {
                if (dealFileCnt === allFileLen - 1) {
                    // getDropFileCallBack(dropFiles);
                }
                dealFileCnt++;
            }

            if (df.items !== undefined) {
                // Chrome拖拽文件逻辑
                for (let i = 0; i < df.items.length; i++) {
                    let item = df.items[i];
                    if (item.kind === "file" && item.webkitGetAsEntry().isFile) {
                        let file = item.getAsFile();
                        dropFiles.push(file);
                    }
                }

                if (dropFiles.length == 1) {
                    setPasterData(dropFiles[0])
                    pasterModalRef.current.show()
                } else {
                    return Message.error('不支持批量操作或者文件夹')
                }

            } else {
                // 非Chrome拖拽文件逻辑
                for (let i = 0; i < allFileLen; i++) {
                    let dropFile = df.files[i];
                    if (dropFile.type) {
                        dropFiles.push(dropFile);
                        checkDropFinish();
                    } else {
                        try {
                            let fileReader = new FileReader();
                            fileReader.readAsDataURL(dropFile.slice(0, 3));

                            fileReader.addEventListener('load', function (e) {
                                console.log(e, 'load');
                                dropFiles.push(dropFile);
                                checkDropFinish();
                            }, false);

                            fileReader.addEventListener('error', function (e) {
                                console.log(e, 'error，不能够上传文件夹');
                                checkDropFinish();
                            }, false);

                        } catch (e) {
                            console.log(e, 'catch error，不能够上传文件夹');
                            checkDropFinish();
                        }
                    }
                }

                if (dropFiles.length == 1) {
                    setPasterData(dropFiles[0])
                    pasterModalRef.current.show()
                } else {
                    return Message.error('不支持批量操作或者文件夹')
                }
            }
        }, false);

    }

    // 按下键盘事件处理函数
    function handleKeyDown(e) {
        //input 是否聚焦
        let isFoucs = document.getElementById('im-input') == document.activeElement

        //enter 的charcode为13
        if (e.keyCode == 13 && !e.shiftKey && isFoucs) {
            e.preventDefault()//阻止默认行为表示 不换行
            onSend()
        } else if (e.keyCode == 13 && e.shiftKey && isFoucs) {
            //不阻止默认行为表示 换行， 此处不再多余操作
        }

    }

    //粘贴板事件处理函数
    const onPaste = (e) => {
        if (e.clipboardData && e.clipboardData.items) {
            let items = e.clipboardData.items || [];
            let file = null;
            if (items && items.length) {
                file = items[0].getAsFile();
                // for (let i = 0; i < items.length; i++) {
                //     if (items[i].type.indexOf('image') !== -1) {
                //         file = items[i].getAsFile();
                //     }
                // }
            }
            let isFoucs = document.getElementById('im-input') == document.activeElement
            // 获取文件之后就可以上传服务器或者其他操作
            if (file != null && isFoucs) {
                setPasterData(file)
                pasterModalRef.current.show()
            }
        }
    }

    //粘贴板确定发送
    function sendPaste() {
        setLoading(true)
        Util.zkCloudUpload([pasterData], '', data => {
            pasterModalRef.current.hide()
            setLoading(false)
            let fileObj = data.respMsg
            fileObj.type = pasterData.type
            fileObj.size = pasterData.size
            if (pasterData.type.indexOf('image') != -1) {
                getImg(fileObj)
            } else {
                getFile(fileObj, true)
            }
        }, '', error => {
            setLoading(false)
        })
    }

    //获取未上传前的url
    function getObjectURL(file) {
        let url = null
        if (window.createObjectURL != undefined) {
            url = window.createObjectURL(file)
        } else if (window.URL != undefined) {
            url = window.URL.createObjectURL(file)
        } else if (window.webkitURL != undefined) {
            url = window.webkitURL.createObjectURL(file)
        }
        return url
    }

    function fileImg(fileName) {
        if (fileName.indexOf('txt') != -1) {
            return txt
        } else if (fileName.indexOf('ppt') != -1) {
            return ppt
        } else if (fileName.indexOf('doc') != -1) {
            return word
        } else if (fileName.indexOf('xlsx') != -1 || fileName.indexOf('xls') != -1 || fileName.indexOf('csv') != -1) {
            return excel
        } else if (fileName.indexOf('pdf') != -1) {
            return pdf
        } else if (fileName.indexOf('zip') != -1 || fileName.indexOf('rar') != -1 || fileName.indexOf(' 7z') != -1 || fileName.indexOf(' gzip') != -1 || fileName.indexOf(' tar.gz') != -1) {
            return zip
        } else if (fileName.indexOf('video') != -1) {
            return 'video'
        } else if (fileName.indexOf('image') != -1) {
            return 'image'
        } else {
            return unknownFile
        }
    }

    useImperativeHandle(ref, () => ({
        // acceptNewMsg: acceptNewMsg,
        acceptNewMsg: acceptNewMsg,
        getTotal: getTotal,
        talklibSend: talklibSend
    }));

    function getTotal(obj) {
        if (obj.data.wxid == wxid) {
            setUnReadTotal(obj.data.notReadNum)
        }
    }

    function getMsgList() {
        setMsgList([])
        setIsOver(false)
        //id变化 请求 聊天内容接口
        let queryParam = {
            pageSize: 20,
            pageNum: 1,
        }
        let bodyData = {
            wxid: wxid,
            chat_wxid: chat_wxid,
        }
        CloudApi.getChatMsgs(queryParam, bodyData, data => {
            //如果有头图，该头图是 私聊的对方头图
            if (chatData && chatData.isRoom == 0 && chatData.avatar) {
                data.list.forEach(item => {
                    item.sendAvator = chatData.avatar
                })
            }
            if (chat_wxid == Util.getUrlArg('chat_wxid')) {
                setMsgList(data.list.reverse())
            }
            setPages(data.pagInfo.pages)
            setIsOver(true)
        }, error => {
        })
    }

    function getNextList(pageNum) {
        setIsOver(false)
        let queryParam = {
            pageSize: 20,
            pageNum: pageNum,
        }
        let bodyData = {
            wxid: wxid,
            chat_wxid: chat_wxid,
        }
        CloudApi.getChatMsgs(queryParam, bodyData, data => {
            //如果有头图，该头图是 私聊的对方头图
            if (chatData && chatData.isRoom == 0 && chatData.avatar) {
                data.list.forEach(item => {
                    item.sendAvator = chatData.avatar
                })
            }
            if (chat_wxid == Util.getUrlArg('chat_wxid')) {
                setMsgList([...data.list.reverse(), ...msgList])
            }
            setIsOver(true)
        }, error => {
        })
    }

    function onChange(e) {
        let value = e.target.value
        setInputValue(value)
        Store.setChatSendMsg(value);
    }

    //获取选中的表情
    function getEmoji(obj) {
        let value = inputValue + obj.text
        setInputValue(value)
        textAreaRef.current.focus()
        Store.setChatSendMsg(value);
    }

    //获取选中的图片
    function getImg(obj) {
        let id = md5(wxid + chat_wxid + nanoid())
        // console.log('9898',obj)
        let fileData = {
            currentUrl: obj.url,
            fileName: obj.fileName
        }
        //追加到消息列表
        msgListRef.current.addSelfMsg(id, 14, '', fileData)

        //socket发送
        let contents = [
            {
                msg_type: 14,
                content: {
                    character: '',//文字
                    picture: obj.url,//图片
                    audioUrl: '', //音频url
                    link: '',//链接
                    linkHeadline: '',//链接标题
                    linkAbstract: '',//链接摘要
                    linkCover: '',//链接封面
                    appletHeadline: '',//小程序标题
                    appletAppId: '',//小程序AppID
                    appletPath: '',//小程序路径
                    appletCover: ''//小程序封面
                }
            }
        ]
        //自己发送消息时， 更新滚动条到最底
        if (msgListRef) {
            msgListRef.current.updateScroll(200)
        }
        outSocket(contents, id)
    }

    //获取填写的link内容
    function getLink(obj) {
        let id = md5(wxid + chat_wxid + nanoid())
        // let obj = {
        //     title: 标题,
        //     address: 链接地址,
        //     content: 描述,
        //     url: 图片url,
        // }
        // 2文本  6位置 14图片 23视频 15文件 13链接 41名片 26红包 29GIF 16语音 78小程序
        let contents = [
            {
                msg_type: 13,
                content: {
                    character: '',//文字
                    picture: '',//图片
                    link: obj.address,//链接
                    linkHeadline: obj.title,//链接标题
                    linkAbstract: obj.content,//链接摘要
                    linkCover: obj.url,//链接封面
                    appletHeadline: '',//小程序标题
                    appletAppId: '',//小程序AppID
                    appletPath: '',//小程序路径
                    appletCover: ''//小程序封面
                }
            }
        ]
        msgListRef.current.addSelfMsg(id, 13, '', obj)
        //自己发送消息时， 更新滚动条到最底
        if (msgListRef) {
            msgListRef.current.updateScroll()
        }
        outSocket(contents, id)
    }

    function getRemind(arr) {
        // console.log('9898@', arr)
        let str = arr.map(item => `@${item.name}`).join(' ') + ' '
        let value = inputValue + str;
        setInputValue(value)
        textAreaRef.current.focus()
    }

    //获取选中的文件
    function getFile(obj, isPaste) {
        let id = md5(wxid + chat_wxid + nanoid())
        let contents = [
            {
                msg_type: 15,
                content: {
                    character: '',//文字
                    picture: '',//图片
                    audioUrl: '', //音频url
                    uploadVideoUrl: '', //视频url
                    uploadFilesUrl: '', //文件url
                    uploadFilesName: '', //文件name
                    link: '',//链接
                    linkHeadline: '',//链接标题
                    linkAbstract: '',//链接摘要
                    linkCover: '',//链接封面
                    appletHeadline: '',//小程序标题
                    appletAppId: '',//小程序AppID
                    appletPath: '',//小程序路径
                    appletCover: ''//小程序封面
                }
            }
        ]
        /**
         * 2文本  6位置 14图片 23视频 15文件 13链接 41名片 26红包 29GIF 16语音 78小程序
         * subType: 文件的具体类型  1图片 2音频 3视频 4文档
         */
        let msgType = ''
        if (obj.type.indexOf('image') != -1) {
            msgType = 15
            contents[0].content.subType = 1
            contents[0].content.picture = !isPaste ? obj.response.respMsg.url : obj.url
            contents[0].content.uploadFilesUrl = !isPaste ? obj.response.respMsg.url : obj.url
            contents[0].content.uploadFilesName = !isPaste ? obj.response.respMsg.fileName : obj.fileName
        } else if (obj.type.indexOf('video') != -1) {
            msgType = 23
            contents[0].content.subType = 3
            contents[0].content.uploadFilesUrl = !isPaste ? obj.response.respMsg.url : obj.url
            contents[0].content.uploadVideoUrl = !isPaste ? obj.response.respMsg.url : obj.url
            contents[0].content.uploadFilesName = !isPaste ? obj.response.respMsg.fileName : obj.fileName
        } else if (obj.type.indexOf('audio') != -1) {
            msgType = 16
            contents[0].content.subType = 2
            contents[0].content.uploadFilesUrl = !isPaste ? obj.response.respMsg.url : obj.url
            contents[0].content.audioUrl = !isPaste ? obj.response.respMsg.url : obj.url
            contents[0].content.uploadFilesName = !isPaste ? obj.response.respMsg.fileName : obj.fileName
        } else {
            msgType = 15
            contents[0].content.subType = 4
            contents[0].content.uploadFilesUrl = !isPaste ? obj.response.respMsg.url : obj.url
            contents[0].content.uploadFilesName = !isPaste ? obj.response.respMsg.fileName : obj.fileName
        }

        let fileData = {
            currentUrl: !isPaste ? obj.response.respMsg.url : obj.url,
            fileName: !isPaste ? obj.response.respMsg.fileName : obj.fileName,
            file_size: obj.size,
            file_contents: contents, //socket要发送的值
        }
        // console.log('9898', obj)
        msgListRef.current.addSelfMsg(id, msgType, '', fileData)
        //自己发送消息时， 更新滚动条到最底
        if (msgListRef) {
            msgListRef.current.updateScroll()
        }
        outSocket(contents, id)
    }

    //引用文本
    function getQuote(item) {
        // console.log('9898getQuote',item)
        /**
         * 拿到引用的值, 与当前输入的值拼接  并且  获取焦点
         */
            // console.log('9898引用', item.msgData.content)
        let str = MixedMessageParser.html2Text(item.msgData.content)
        // console.log('9898引用', str)
        let removeImg = MixedMessageParser.parserEmojiToText(str)
        // console.log('9898引用', removeImg)
        // console.log('9898',item.msgData.content, '-----------',removeImg)
        setInputValue(inputValue + `${inputValue ? '\n' : ''}「${item.senderName || chatData.name}：${removeImg}」\n` + '--------------\n')
        textAreaRef.current.focus()
    }

    const useGetQuote = useCallback(getQuote, [JSON.stringify(chatData)])

    //接受新消息
    function acceptNewMsg(obj) {
        clearTimeout(timer)
        /**
         * 2文本  6位置 14图片 23视频 15文件 13链接 41名片 26红包 29GIF 16语音 78小程序
         */
        let isRoom = chat_wxid.startsWith('R')  //是否群聊
        let msg = {
            msgData: obj.data,
            msgType: obj.data.msgtype,
            senderId: obj.data.sender_id,
            senderName: isRoom ? obj.data.sender_nickname : '',
            sendAvator: isRoom ? obj.data.sendAvator : chatData.avatar,
            corpShortName: isRoom ? obj.data.corpShortName : '',
            msgTime: '',
        }
        msgListRef.current.acceptMsg(msg, 'socket')
    }

    //输入框的转义\n 换成br 标签 ， 链接换为 a标签
    function textToHtml(message) {
        let regexp = /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|\&|-)+)/g;
        let content = message.replace(regexp, function ($url) {
            return "<a href='" + $url + "' target='_blank'>" + $url + "</a>";
        }).replace(new RegExp('\n', 'gm'), '<br />')

        return content
    }

    //点击发送文本消息
    function onSend() {
        // return
        if (inputValue == '') return
        /**
         * 1，点击发送，先打包发送的内容
         *,2，传值
         * 3，发送完成，清空输入框内容
         */
        let msgParser = MixedMessageParser.parser(inputValue)  //拆分好的消息
        let isRemind = msgParser.some(item => item.subtype == 1)  //是否有@
        // let isEmoji = msgParser.some(item => item.subtype == 2)  //是否有表情
        let isMix = msgParser.some(item => item.subtype != 0)  //是否是混合消息
        let arr = []
        let nameStr = ''
        //若有modal@的， modal@的 和 单个@的 合并
        // console.log('9898parser', msgParser, '----', isMix)
        if (isRemind && remindRef) {
            arr = remindRef.current ? remindRef.current.selectData().concat(oneRemind) : oneRemind
            nameStr = arr.map(item => `@${item.name}`).join()
            msgParser.forEach(item => {
                if (item.subtype == 1) {
                    if (nameStr.indexOf(item.text) != -1) {
                        arr.forEach(obj => {
                            if (`@${obj.name}` == item.text) {
                                item.text = obj.userId
                            }
                        })
                    } else {
                        item.subtype = 0
                    }
                }
            })
        } else {
            arr = oneRemind
            nameStr = arr.map(item => `@${item.name}`).join()
        }

        //打包要添加的消息数据
        let id = md5(wxid + chat_wxid + nanoid())
        let newValue = textToHtml(inputValue)
        //混合发送
        if (isMix) {
            let contents = [{
                msg_type: 5001,
                content: {
                    mixed_data: msgParser
                }
            }]
            //先追加到消息列表
            // addSelfMsg(id, 2, newValue, {}, contents)
            msgListRef.current.addSelfMsg(id, 2, newValue, {}, contents)
            //再推Socket
            outSocket(contents, id)
        } else {
            let contents = [
                {
                    msg_type: 2,
                    content: {
                        character: inputValue,//文字
                        picture: '',//图片
                        audioUrl: '', //音频url
                        link: '',//链接
                        linkHeadline: '',//链接标题
                        linkAbstract: '',//链接摘要
                        linkCover: '',//链接封面
                        appletHeadline: '',//小程序标题
                        appletAppId: '',//小程序AppID
                        appletPath: '',//小程序路径
                        appletCover: ''//小程序封面
                    }
                }
            ]
            // addSelfMsg(id, 2, newValue)
            msgListRef.current.addSelfMsg(id, 2, newValue)
            //再推Socket
            outSocket(contents, id)
        }
        setInputValue('')
        //自己发送消息时， 更新滚动条到最底
        if (msgListRef) {
            msgListRef.current.updateScroll()
        }
        setOneRemind([])
        Store.clearChatSendMsg();
    }

    //素材库发送
    function talklibSend(msgArr) {
        // console.log('9898', msgArr)
        // msgArr=[msgArr]
        msgArr.forEach((item, index) => {
            let id = md5(wxid + chat_wxid + nanoid())
            let contents = []
            /**
             * 2文本  6位置 14图片 23视频 15文件 13链接 41名片 26红包 29GIF 16语音 78小程序   10001撤回消息
             */
            if (item.msg_type == 2) {
                let msgParser = MixedMessageParser.parser(item.content.character)  //拆分好的消息
                let isMix = msgParser.some(item => item.subtype != 0)  //是否是混合消息
                if (isMix) {
                    contents.push({
                        msg_type: 5001,
                        content: {
                            mixed_data: msgParser
                        }
                    })
                    //先追加到消息列表
                    msgListRef.current.addSelfMsg(id, 2, '', {}, contents)
                    outSocket(contents, id)
                } else {
                    contents.push({
                        msg_type: 2,
                        content: {
                            character: item.content.character,//文字
                        }
                    })
                    //先追加到消息列表
                    msgListRef.current.addSelfMsg(id, 2, item.content.character)
                    outSocket(contents, id)
                }
            } else if (item.msg_type == 13) {
                contents.push({
                    msg_type: 13,
                    content: {
                        link: item.content.link,//链接
                        linkHeadline: item.content.linkHeadline,//链接标题
                        linkAbstract: item.content.linkAbstract,//链接摘要
                        linkCover: item.content.linkCover,//链接封面
                        appletHeadline: '',//小程序标题
                        appletAppId: '',//小程序AppID
                        appletPath: '',//小程序路径
                        appletCover: ''//小程序封面
                    }
                })
                //先追加到消息列表
                msgListRef.current.addSelfMsg(id, 13, '', contents)
                outSocket(contents, id)
            } else if (item.msg_type == 14) {
                // console.log(item.content,'图片')
                contents.push({
                    msg_type: 14,
                    content: {
                        picture: item.content.picture,//图片
                        file_aeskey: item.content.file_aeskey,
                        file_md5: item.content.file_md5,
                        file_size: item.content.file_size,
                        file_url: item.content.file_url,
                    }
                })
                let fileData = {
                    currentUrl: item.content.picture,
                    fileName: item.content.fileName
                }
                //追加到消息列表
                msgListRef.current.addSelfMsg(id, 14, '', fileData)
                outSocket(contents, id)
            } else if (item.msg_type == 15) {
                // console.log(item.content,'文件')
                let contents = [
                    {
                        msg_type: 15,
                        content: {
                            uploadFilesUrl: item.content.uploadFilesUrl, //文件url
                            uploadFilesName: item.content.uploadFilesName, //文件name
                            file_aeskey: item.content.file_aeskey,
                            file_md5: item.content.file_md5,
                            file_size: item.content.file_size,
                            file_url: item.content.file_url,
                        }
                    }
                ]
                contents[0].content = item.content
                contents[0].content.subType = 4
                outSocket(contents, id)
            } else if (item.msg_type == 16) {
                // console.log(item.content,'语音')
                let contents = [
                    {
                        msg_type: 16,
                        content: {
                            uploadAudioUrl: item.content.uploadAudioUrl,
                            uploadAudioName: item.content.uploadAudioName,
                            file_aeskey: item.content.file_aeskey,
                            file_md5: item.content.file_md5,
                            file_size: item.content.file_size,
                            file_url: item.content.file_url,
                        }
                    }
                ]
                contents[0].content = item.content
                outSocket(contents, id)
            } else if (item.msg_type == 78) {
                // console.log(item.content,'小程序')
                let contents = [
                    {
                        msg_type: 78,
                        content: {
                            appid: item.content.appid,
                            coverimgurl: item.content.coverimgurl,
                            desc: item.content.desc,
                            file_aeskey: item.content.file_aeskey,
                            file_id: item.content.file_id,
                            file_md5: item.content.file_md5,
                            file_size: item.content.file_size,
                            pagepath: item.content.pagepath,
                            thumburl: item.content.thumburl,
                            title: item.content.title,
                            username: item.content.username,
                        }
                    }
                ]
                contents[0].content = item.content
                outSocket(contents, id)
            } else if (item.msg_type == 23) {
                // console.log(item.content,'视频')
                let contents = [
                    {
                        msg_type: 23,
                        content: {
                            uploadVideoUrl: item.content.uploadVideoUrl, //视频url
                            uploadVideoName: item.content.uploadVideoName, //视频名字
                            duration: item.content.duration,
                            file_aeskey: item.content.file_aeskey,
                            file_md5: item.content.file_md5,
                            file_size: item.content.file_size,
                            file_url: item.content.file_url,
                        }
                    }
                ]
                contents[0].content = item.content
                outSocket(contents, id)
            } else if (item.msg_type == 141) {
                // console.log(item.content,'视频号')
                let contents = [{
                    msg_type: 141,
                    content: {
                        channel_name: item.content.channel_name,
                        channel_url: item.content.channel_url,
                        encode_data: item.content.encode_data,
                        head_img_url: item.content.head_img_url,
                        thumb_url: item.content.thumb_url,
                        username: item.content.username,
                    }
                }]
                contents[0].content = item.content
                contents[0].content.subType = 3
                outSocket(contents, id)
            }
            //接受socket发送成功的消息  获取这个的下标

        })
    }

    //重发消息
    function reSend(obj) {
        // console.log('9898reSend', obj)
        if ((obj.msgType == 2 || obj.msgType == 0) && obj.msgData.mixContents == undefined) {
            let contents = [
                {
                    msg_type: 2,
                    content: {
                        character: obj.msgData.content,//文字
                        picture: '',//图片
                        audioUrl: '', //音频url
                        link: '',//链接
                        linkHeadline: '',//链接标题
                        linkAbstract: '',//链接摘要
                        linkCover: '',//链接封面
                    }
                }
            ]
            reSendSocket(contents, obj.msgData.msgSendId)
        } else if ((obj.msgType == 2 || obj.msgType == 0) && obj.msgData.mixContents != undefined) {
            reSendSocket(obj.msgData.mixContents, obj.msgData.msgSendId)
        } else if (obj.msgType == 14) {
            let contents = [
                {
                    msg_type: 14,
                    content: {
                        character: '',//文字
                        picture: obj.currentUrl,//图片
                        audioUrl: '', //音频url
                        link: '',//链接
                        linkHeadline: '',//链接标题
                        linkAbstract: '',//链接摘要
                        linkCover: '',//链接封面
                        appletHeadline: '',//小程序标题
                        appletAppId: '',//小程序AppID
                        appletPath: '',//小程序路径
                        appletCover: ''//小程序封面
                    }
                }
            ]
            reSendSocket(contents, obj.msgData.msgSendId)
        } else if (obj.msgType == 15) {
            reSendSocket(obj.msgData.file_contents, obj.msgData.msgSendId)
        } else if (obj.msgType == 13) {
            // console.log('9898link', obj)
            let contents = [
                {
                    msg_type: 13,
                    content: {
                        character: '',//文字
                        picture: '',//图片
                        link: obj.msgData.url,//链接
                        linkHeadline: obj.msgData.title,//链接标题
                        linkAbstract: obj.msgData.des,//链接摘要
                        linkCover: obj.msgData.thumburl,//链接封面
                        appletHeadline: '',//小程序标题
                        appletAppId: '',//小程序AppID
                        appletPath: '',//小程序路径
                        appletCover: ''//小程序封面
                    }
                }
            ]
            reSendSocket(contents, obj.msgData.msgSendId)
        }
    }

    const useReSend = useCallback(reSend, [])

    //自己发送时，追加消息，  MD5id, 发送的类型msgType 发送的文本内容content，文件对象fileData, 解析完毕的混合消息对象mixContents
    function addSelfMsg(id, msgType, content, fileData, mixContents) {
        let msg = {
            msgData: {
                mixContents: mixContents, //混合消息的字段
                content: content,
                msgSendId: id,
                // content_back: "MTExMQ==",
                conversation_id: chat_wxid,
                file_name: fileData ? fileData.fileName : '',
                file_size: fileData ? fileData.file_size : '',
                file_contents: fileData ? fileData.file_contents : '',//发送文件是的socket数据
                url: fileData ? fileData.address : '', //链接 url
                title: fileData ? fileData.title : '', //链接 title
                des: fileData ? fileData.content : '',//链接 content
                thumburl: fileData ? fileData.url : '',//链接 图片
            },
            loading: true,
            send_fail: undefined,
            msgType: msgType,
            currentUrl: fileData ? fileData.currentUrl : '',
            senderId: wxid,
            senderName: '',
            sendAvator: '',
            corpShortName: '',
            msgTime: '',
        }
        setNewMsg(msg)
    }

    function getOneRemind(obj) {
        oneRemind.push({subtype: 1, userId: obj.senderId, name: obj.senderName})
        setOneRemind(oneRemind)
        setInputValue(inputValue + `@${obj.senderName}` + ' ')
        textAreaRef.current.focus()
    }

    const useGetOneRemind = useCallback(getOneRemind, [])

    function openInput() {
        setRoomInput(true)
    }

    //修改群名称
    function updateRoomName() {
        setRoomInput(false)
        if (roomName == '') return
        let bodyData = {
            wxid: wxid,
            chat_wxid: chat_wxid,
            newName: roomName
        }

        CloudApi.updateChatRoomName(bodyData, data => {
            // Message.success('群名称修改成功')
        }, error => {
            // Message.error('群名称修改失败')
        })
    }

    function editRoomName(e) {
        let value = e.target.value
        setRoomName(value)
    }

    //屏蔽浏览器默认右键菜单
    function doNothing() {
        window.event.returnValue = false;
        return false;
    }

    //文件是否能发送
    function isFileSend() {
        if (pasterData && pasterData.size == 0) {
            return true
        } else if (pasterData && pasterData.size > Vars.FILE_MAXSIZE()) {
            return true
        }
        return false
    }

    return (
        <div className={'chatroom-max'} onContextMenu={doNothing} id={'im-chat-root'}>
            <div className={'im-drop-mask'} id={'im-chat-root-mask'} style={{display: dropEnter ? '' : 'none'}}></div>
            {/*{聊天头}*/}
            <div className={'chatroom-header'}>
                <div className={'chat-header-left'}>
                    {
                        roomInput ?
                            <Input placeholder="修改群聊名称"
                                   allowClear
                                   onChange={editRoomName}
                                   value={roomName}
                                   onBlur={() => {
                                       updateRoomName()
                                       setRoomInput(false)
                                   }}//失去焦点
                                   className={'chat-roomName-input'}
                                   autoFocus={true}
                                   onPressEnter={() => {
                                       updateRoomName()
                                       setRoomInput(false)
                                   }}
                            /> :
                            <span>{roomName}</span>
                    }
                    {
                        chatData.isRoom == 1 ?
                            <>
                                <Tooltip placement="top" title={'修改群名称'}>
                                    <span onClick={roomInput ? updateRoomName : openInput}>
                                        <IconEdit/>
                                    </span>
                                </Tooltip><span>{` (${roomTotal}) `}</span>
                            </> : ''
                    }
                </div>
                {/*<a className={'chat-header-right'}>{'查看更多群聊消息'} <span><IconRight/></span></a>*/}
            </div>

            {/*{聊天中间内容}*/}
            <div className={'chatroom-middle'}>
                <MessageListClass
                    getQuote={useGetQuote} outSocket={outSocket}
                    getOneRemind={useGetOneRemind} reSend={useReSend}
                    reCallSocket={reCallSocket}
                    newMsg={newMsg}
                    ref={msgListRef} chatData={chatData}
                    wxid={wxid} chat_wxid={chat_wxid}
                    chatDataSelf={chatDataSelf}
                    isOver={isOver} pages={pages}
                    leftSelect={leftSelect}
                >
                </MessageListClass>
            </div>

            {/*{聊天底部}*/}
            <div className={'chatroom-bottom'} id={'zk-chatroom-bottom-id'}>
                {
                    leftSelect.lineStatus == 1 ?
                        <>
                            <Space size={'middle'}>
                                <ImEmoji getEmoji={getEmoji}></ImEmoji>
                                <ImPicture getImg={getImg} chatData={chatData}></ImPicture>
                                <ImFile getFile={getFile} chatData={chatData}></ImFile>
                                <ImLink getLink={getLink}></ImLink>
                                {
                                    chat_wxid.startsWith('R') ?
                                        <Remind ref={remindRef} chatRoomId={chat_wxid} getRemind={getRemind}></Remind>
                                        : ''
                                }
                                <RecordIcon></RecordIcon>
                            </Space>
                            <TextArea className={'msg-input-area'}
                                      onKeyDown={e => handleKeyDown(e)}
                                      ref={textAreaRef}
                                      id={'im-input'}
                                      onChange={onChange}
                                      value={inputValue}
                                      bordered={false}
                                      placeholder={`请输入消息  按下Enter发送  按下Shift + Enter换行\nCtrl + v可发送剪切或复制的图片和文件`}
                                      autoSize={{minRows: 6, maxRows: 6}}
                            />
                            <div className={'chat_bottom_max'}>
                                <div className={'chat_right_btn'}>
                                    <Radio.Group>
                                        <Radio.Button className={'tt'}
                                                      onClick={() => endConversation(chat_wxid)}>结束对话</Radio.Button>
                                        <Badge count={unReadTotal}>
                                            <Radio.Button className={'tt'} onClick={nextUnRead}
                                                          disabled={unReadTotal == 0 ? true : false}>下一个未读</Radio.Button>
                                        </Badge>
                                        <Button type={'primary'} className={'chat_send_btn'}
                                                onClick={onSend}>发送</Button>
                                    </Radio.Group>
                                </div>
                            </div>
                        </>
                        :
                        <div className={'im-off-line'}>
                            {
                                //离线状态时是否可以登录 0：不是，1是；
                                leftSelect.canLogin == 1 ?
                                    <>
                                        <ImLogin ref={imLoginRef} data={leftSelect} wxid={wxid}
                                                 afterSuccess={leftUpdate}>
                                        </ImLogin>
                                        <p>{'账号离线，无法进行会话聊天'}</p>
                                        <Button type={'primary'}
                                                onClick={() => imLoginRef.current.wxLogin()}>{'立即登录'}
                                        </Button>
                                    </>
                                    :
                                    <>
                                        <img src={offLine} className={'offline-sub-s1'}/>
                                        <p>{'账号离线，无法进行会话聊天'}</p>
                                        <p>{`请去`} <span
                                            style={{color: '#146FF8'}}>{`${leftSelect.subAccountName}`}</span> {'子账号下登录当前企微号'}
                                        </p>
                                    </>
                            }
                        </div>
                }
                {/*{粘贴板发送modal}*/}
                <ZkModal title={'发送给：'} ref={pasterModalRef} width={480}
                         footer={[
                             <Button onClick={() => {
                                 pasterModalRef.current.hide()
                             }}>取消
                             </Button>,
                             <Button loading={loading} type="primary" onClick={sendPaste}
                                     disabled={isFileSend()}
                             >
                                 确定
                             </Button>,
                         ]}
                         maskClosable={false} className={'modal-right-btn im-setting-modal'}
                         afterClose={null}
                         destroyOnClose
                >
                    {/*{sender info}*/}
                    <div className={'im-file-sender'}>
                        {
                            chatData.isRoom == 1 ?
                                <>
                                    <img src={chatData.avatar}/>
                                    <span>{chatData.name}</span>
                                </>
                                :
                                <>
                                    <img src={chatData.avatar}/>
                                    <span>{chatData.name}</span>
                                    <span
                                        className={chatData.corpShortName == '微信' ? 'title-wxName' : 'title-corpName'}>
                                        {chatData.corpShortName ? `@${chatData.corpShortName}` : ''}
                                    </span>
                                </>
                        }
                    </div>
                    <Divider className={'im-file-divider'}/>
                    {/*{发送内容}*/}
                    {
                        pasterData && pasterData.type && pasterData.type.includes('image') ?
                            <div className={'im-file-content'}>
                                <img src={getObjectURL(pasterData)}/>
                                <div className={'im-file-right'}>
                                    <span>{pasterData.name}</span>
                                    <span>{Util.fileSizeToString(pasterData.size)}</span>
                                </div>
                            </div> :
                            pasterData && pasterData.type ?
                                <div className={'im-file-content'}>
                                    {
                                        fileImg(pasterData.type) == 'video' ?
                                            <video className={'im-file-video'}>
                                                <source
                                                    src={getObjectURL(pasterData)}
                                                    type="video/mp4"/>
                                                {/*<source src={item.msgData} type="video/ogg" />*/}
                                                您的浏览器不支持 视频。
                                            </video>
                                            :
                                            fileImg(pasterData.type) == 'image' ?
                                                <img src={getObjectURL(pasterData)}/> :
                                                <img src={fileImg(pasterData.name)}/>
                                    }
                                    <div className={'im-file-right'}>
                                        <span>{pasterData.name}</span>
                                        <span>{Util.fileSizeToString(pasterData.size)}</span>
                                    </div>
                                </div> :
                                pasterData && pasterData.type == '' ?
                                    <div className={'im-file-content'}>
                                        <img src={unknownFile}/>
                                        <div className={'im-file-right'}>
                                            <span>{pasterData.name}</span>
                                            <span>{Util.fileSizeToString(pasterData.size)}</span>
                                        </div>
                                    </div> : ''
                    }
                    {/*{空文件 或 超出大小的警告}*/}
                    {
                        pasterData && pasterData.size == 0 ?
                            <Alert message="无法发送空文件" type="error" showIcon className={'im-file-warning'}/> :
                            pasterData && pasterData.size > Vars.FILE_MAXSIZE() ?
                                <Alert message="文件大小超过50M，无法发送" type="error" showIcon
                                       className={'im-file-warning'}/> : ''
                    }
                </ZkModal>
            </div>
        </div>
    )
});

export default React.memo(ChatRoom)